import { Location } from '@angular/common';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from './../../../../environments/environment';
import { ApiService } from './../api/api.service';
import { ConfigService } from './../../config/config/config.service';
import { UtilityCookieService as utilityCookie } from './../../utils/cookie/utilitycookie.service';
import { StorageService } from './../storage/storage.service';
import { MemberService } from './../member/member.service';
import { ResponseValidator } from './../../utils/response-validator';
import { isURL } from './../../utils/util';
import { localConsole } from './../../utils/local-console';
import * as i0 from "@angular/core";
import * as i1 from "../api/api.service";
import * as i2 from "../../config/config/config.service";
import * as i3 from "../member/member.service";
import * as i4 from "../storage/storage.service";
import * as i5 from "@angular/common";
var LoginService = /** @class */ (function () {
    function LoginService(apiService, config, member, storage, _location, baseHref) {
        this.apiService = apiService;
        this.config = config;
        this.member = member;
        this.storage = storage;
        this._location = _location;
        this.baseHref = baseHref;
        this.oneSiteCookie = this.config.get('oneSiteCookieName'); // CVS_SSO_TOKEN
        this.hcOneSiteCookie = this.config.get('hcOneSiteCookieName'); // CVS_SSO_TOKEN, hardcoded fallback
        this.authLoginCookie = this.config.get('authLoginCookieName'); // AUTH_LOGIN
        this.sccCookie = this.config.get('sccCookieName'); // SCC_COOKIE
        this.userSsoToken = this.config.get('userSSoToken'); // USER_SSOTOKEN
        this.iceCookie = this.config.get('iceCookieName'); // ICE
        this.cookiesDomain = this.config.get('cookiesDomain');
        this.cookiesSecure = this.config.get('cookiesSecure');
        this.userData = {};
        this.authState = new BehaviorSubject({ authenticated: false, data: null });
        this.errorNumber = null;
        this.activeMember = this.getActiveMemberByIndex();
    }
    /**
     * Used for development only to authenticate
     * with username and password
     */
    LoginService.prototype.authenticate = function (credentials) {
        var _this = this;
        var requestObj = {
            'request': {
                'header': {
                    'apiKey': this.config.get('mdp'),
                    'appName': this.config.getMdpAppName(),
                    'channelName': this.config.get('channelName') || 'WEB',
                    'deviceToken': 'd9708df38d23192e',
                    'deviceType': this.config.getDeviceType(),
                    'lineOfBusiness': 'ICE',
                    'responseFormat': 'JSON',
                    'securityType': 'apiKey',
                    'source': 'MDP_WEB'
                },
                'source': 'retail',
                'username': credentials.emailAddress,
                'password': credentials.password
            }
        };
        return this.apiService
            .post('authenticateUser', null, requestObj, { observe: 'response' }).pipe(map(function (res) { return _this.transformResponse(res); }));
    };
    /**
     * Retrieve activeMember from session
     * param Index - index from memberInfo Object
     * param memberInfo - list of users
     */
    LoginService.prototype.getActiveMemberByIndex = function () {
        var memberIndex = this.storage.get('activeMemberIndex', this.storage.sessionStorage);
        var memberDetails = this.storage.get('memberDetails', this.storage.sessionStorage);
        if (memberIndex && memberDetails && memberDetails.memberInfoResponse) {
            var memberInfo = memberDetails.memberInfoResponse[0].memberInfo;
            memberInfo = Array.isArray(memberInfo) ? memberInfo : [memberInfo];
            return memberInfo && memberInfo.find(function (user) {
                return user.memberIndex === memberIndex;
            });
        }
        return null;
    };
    /**
     * Check in session storage for memberDetails property
     * validate expire, compare to current time
     * @returns boolean | return false by default
     */
    LoginService.prototype.checkAuthSession = function (notify) {
        var loggedIn = this.storage.get('memberDetails', this.storage.sessionStorage);
        if (loggedIn) {
            if (loggedIn.expire) {
                if (loggedIn.expire > new Date().getTime()) {
                    if (notify) {
                        var session = this.storage.get('memberDetails', this.storage.sessionStorage);
                        var history_1 = session.prescriptionHistory;
                        this.processAuthResp({
                            getLinkedMembersDetails: {
                                encRxConnectId: session.encRxConnectId,
                                expire: session.expire,
                                memberInfoResponse: session.memberInfoResponse
                            },
                            prescriptionHistory: history_1,
                            rxTied: session.rxTied
                        }, true);
                    }
                    return true;
                }
            }
        }
        this._tearDownAuthSession();
        return false;
    };
    /**
     * Add memberDetails to session storage
     * data | memebrDetails object retrieved
     * from Authentication response
     */
    LoginService.prototype._setUpAuthSession = function (data) {
        /**
         * Start auth session
         */
        var exp = new Date();
        exp.setTime(exp.getTime() + (1 * 60 * 60 * 1000));
        Object.assign(data, { expire: exp.getTime() });
        this.storage.set('memberDetails', data, this.storage.sessionStorage);
    };
    /**
     * Deletes memberDetails from session storage
     */
    LoginService.prototype._tearDownAuthSession = function () {
        this.storage.remove('memberDetails');
        this.storage.remove('activeMemberIndex');
    };
    /**
     * Validate auth response and return detail object
     */
    LoginService.prototype.transformResponse = function (response) {
        this.authResponse = response;
        if (response && response.response && response.response.header) {
            var message = response.response.header.statusDesc || response.response.header.statusDescription || '';
            /* 0000 => success code in response */
            if (response.response.header.statusCode === '0000') {
                /**
                 * Process Auth response
                 */
                this.processAuthResp(response.response.detail);
                if (message.indexOf('RETAIL_GET_LINKED_MEMBER_FAILED') > -1) {
                    return response.response.header;
                }
                return response.response.detail;
            }
            else {
                return response.response.header;
            }
        }
        return response;
    };
    /**
     * Pull members information. There are 4 styles in which member
     * info is passed in response which is handled below
     * - Capture primary patient and dispatch it
     * - Setup auth session data
     * param detail - Response returned from authenticateUser V9
     * @returns any | used as void
     */
    LoginService.prototype.processAuthResp = function (detail, mock) {
        var _this = this;
        var isFromOneDashboard = this.storage.sessionStorage.getItem('is_from_one_dashboard');
        var memberInfoResponse = [], primary = {}, memberId = null, email = '', onesiteToken = '', prescriptionHistory = {};
        var encRxConnectId, rxTied, tokenId;
        var careGivees = [];
        email = detail.getLinkedMembersDetails.email ? detail.getLinkedMembersDetails.email : '';
        if (isFromOneDashboard) {
            // const memberDetailsObject = JSON.parse(this.storage.sessionStorage.getItem('memberDetails'));
            var activeMemberIndex_1 = parseInt(this.storage.sessionStorage.getItem('activeMemberIndex'), 10);
            var userSessionObject = JSON.parse(this.storage.sessionStorage.getItem('user'));
            var memberDetailsObject = JSON.parse(this.storage.sessionStorage.getItem('memberDetails'));
            memberInfoResponse = memberDetailsObject && memberDetailsObject.memberInfoResponse; // [0].memberInfo;
            // memberDetailsObject.memberInfoResponse[0].memberInfo.emailAddress;
            // const memberInfoResponse = memberDetailsObject.memberInfoResponse[0].memberInfo;
            var membersList = []; // memberDetailsObject.memberInfoResponse;
            membersList = memberDetailsObject.lobMemberInfo.filter(function (memInfo, index) {
                return (memInfo.lineOfBusiness === 'Retail' || memInfo.lob === 'Retail');
            });
            var memberInfo = membersList.find(function (m) { return m.memberInfo.memberIndex === activeMemberIndex_1; }).memberInfo;
            membersList.forEach(function (memeberObj) {
                var member = memeberObj && memeberObj.memberInfo;
                if (member && member.type === 'primary') {
                    primary = member;
                    primary['emailAddress'] = primary['emailAddress'] || email || '';
                }
                else if ((member.type || '').toLowerCase() === 'caregivee') {
                    careGivees.push(member);
                }
                memberId = member && member.memberId;
                _this.memberId = member && member.encMemberId;
            });
            encRxConnectId = memberDetailsObject.encRxConnectId;
            tokenId = userSessionObject.tokenId;
            rxTied = mock ? memberDetailsObject.rxTied : userSessionObject.rxConnectId !== '';
            /**
             * Capture primary patient and dispatch it
             */
            this.userData = {
                authenticated: true,
                tokenId: tokenId,
                data: memberInfo,
                caregivee: memberInfo.type === 'caregivee',
                detail: memberDetailsObject,
                encRxConnectId: encRxConnectId,
                rxTied: rxTied,
                mocked: mock
            };
            onesiteToken = userSessionObject.oneSiteToken;
            prescriptionHistory = JSON.parse(this.storage.sessionStorage.getItem('rxhistory')).data.response.detail.prescriptionHistoryDetails;
            this.activeMember = this.getActiveMemberByIndex();
        }
        else {
            // getLinkedMembersDetails.memberInfoResponse => lobMemberInfo -> memberInfo
            // getLinkedMembersDetails.email => lobMemberInfo -> memberInfo -> emailAddress
            memberInfoResponse = detail.getLinkedMembersDetails.memberInfoResponse;
            // , primary = {}, memberId = null,
            //  email = '';
            email = detail.getLinkedMembersDetails.email ? detail.getLinkedMembersDetails.email : '';
            if (memberInfoResponse) {
                if (!Array.isArray(memberInfoResponse)) {
                    memberInfoResponse = new Array();
                    memberInfoResponse.push(detail.getLinkedMembersDetails.memberInfoResponse);
                }
                memberInfoResponse.filter(function (memInfo, index) {
                    return (memInfo.lineOfBusiness === 'Retail' || memInfo.lob === 'Retail');
                });
                var membersList = memberInfoResponse[0].memberInfo;
                if (!Array.isArray(memberInfoResponse[0].memberInfo)) {
                    membersList = [memberInfoResponse[0].memberInfo];
                }
                membersList.forEach(function (member) {
                    if (member.type === 'primary') {
                        primary = member;
                        primary['emailAddress'] = primary['emailAddress'] || email || '';
                        memberId = member.memberId;
                        _this.memberId = member.encMemberId;
                    }
                    else if ((member.type || '').toLowerCase() === 'caregivee') {
                        careGivees.push(member);
                    }
                });
                encRxConnectId = detail.getLinkedMembersDetails.encRxConnectId;
                tokenId = detail.tokenID;
                rxTied = mock ? detail.rxTied : detail.getLinkedMembersDetails.rxConnectId !== '';
                /**
                 * Capture primary patient and dispatch it
                 */
                this.userData = {
                    authenticated: true,
                    tokenId: detail.tokenID,
                    data: primary,
                    detail: detail,
                    encRxConnectId: detail.getLinkedMembersDetails.encRxConnectId,
                    rxTied: mock ? detail.rxTied : detail.getLinkedMembersDetails.rxConnectId !== '',
                    mocked: mock
                };
                onesiteToken = detail.getLinkedMembersDetails.oneSiteToken;
                prescriptionHistory = detail.prescriptionHistory;
            }
            if (careGivees.length) {
                Object.assign(this.userData, { careGivees: careGivees, careGiver: primary });
            }
            this.authState.next(this.userData);
            /**
             * Data needed from auth response to run the app
             * Update as necessary to expose more
             */
            this._setUpAuthSession({
                memberInfoResponse: memberInfoResponse,
                token: tokenId,
                prescriptionHistory: detail.prescriptionHistory,
                encRxConnectId: encRxConnectId,
                rxTied: rxTied,
            });
            /**
             * Save tokenID for re-use
             */
            if (tokenId) {
                this.saveTokenId(tokenId);
            }
            /**
             * Create CVS_SSO_TOKEN token
             */
            if (onesiteToken) {
                this.createOneSiteCookie(onesiteToken);
            }
        }
        return memberId;
    };
    /**
     * Save authentication detail.tokenId in sessionStorage
     */
    LoginService.prototype.saveTokenId = function (str) {
        this.tokenId = str;
        this.storage.set('token', str, this.storage.sessionStorage);
    };
    /**
     * Create cookie with authentication detail.getLinkedMembersDetails.oneSiteToken
     */
    LoginService.prototype.createOneSiteCookie = function (token) {
        utilityCookie.setCookie({
            name: this.oneSiteCookie, value: token, path: '/',
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
        this.storage.set('oneSiteRefresh', new Date(), this.storage.sessionStorage);
    };
    /**
     * Create all authentication related cookies
     */
    LoginService.prototype.deleteCookies = function () {
        this.deleteOneSiteCookie();
        this.deleteAuthLoginCookie();
        this.deleteUserToken();
        this.deleteSccCookie();
        this.deleteUserSsoToken();
        this.deleteIceCookie();
        this.deleteJessionIdCookie();
        this.storage.sessionStorage.removeItem('is-from-one-dashboard');
    };
    /**
     * Delete authentication tokenID cookie
     */
    LoginService.prototype.deleteOneSiteCookie = function () {
        utilityCookie.deleteCookie({
            name: this.oneSiteCookie, value: null, path: '/', expires: -1,
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
        this.storage.sessionStorage.removeItem('oneSiteRefresh');
    };
    /**
     * Delete authentication AUTH_LOGIN cookie
     */
    LoginService.prototype.deleteAuthLoginCookie = function () {
        utilityCookie.deleteCookie({
            name: this.authLoginCookie, value: null, path: '/', expires: -1,
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
    };
    /**
     * Delete authentication SCC_COOKIE cookie
     */
    LoginService.prototype.deleteSccCookie = function () {
        utilityCookie.deleteCookie({
            name: this.sccCookie, value: null, path: '/', expires: -1,
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
    };
    /**
     * Delete authentication SCC_COOKIE cookie
     */
    LoginService.prototype.deleteUserSsoToken = function () {
        utilityCookie.deleteCookie({
            name: this.userSsoToken, value: null, path: '/', expires: -1,
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
    };
    /**
     * Delete authentication ICE cookie
     */
    LoginService.prototype.deleteIceCookie = function () {
        utilityCookie.deleteCookie({
            name: this.iceCookie, value: null, path: '/', expires: -1,
            domain: this.cookiesDomain, secure: this.cookiesSecure
        });
    };
    LoginService.prototype.deleteJessionIdCookie = function () {
        utilityCookie.deleteCookie({
            name: 'JSESSIONID', value: null, path: '/', expires: -1,
            domain: this.cookiesDomain
        });
    };
    /**
     * Delete USER_TOKEN loginCookies authentication flag
     */
    LoginService.prototype.deleteUserToken = function () {
        utilityCookie.deleteCookie({
            name: this.config.get('authLoginCookies'), value: null, path: '/', expires: -1,
            domain: this.cookiesDomain
        });
    };
    LoginService.prototype.getSSOCookieValues = function () {
        var ssoCookies = {};
        var shouldLoginCookies = utilityCookie.assertCookieValue(this.config.get('authLoginCookies'), 'ON');
        var userSSoToken = utilityCookie.assertCookieValue(this.config.get('userSSoToken'), 'ON');
        ssoCookies.shouldLoginCookies = shouldLoginCookies;
        ssoCookies.oneSitetokenID = utilityCookie.getCookie(this.oneSiteCookie);
        // 03/03/2020 RXMGMT-17722
        // check if loginCookies is enabled
        // skip cookie check if user_token is on
        // TBD: remove when loginCookies is permanently on
        if (!shouldLoginCookies) {
            ssoCookies.authLogin = utilityCookie.getCookie(this.authLoginCookie);
            ssoCookies.sccCookie = utilityCookie.getCookie(this.sccCookie);
        }
        if (userSSoToken) {
            ssoCookies.userSSoToken = utilityCookie.getCookie(this.userSsoToken);
        }
        if (ssoCookies.oneSitetokenID && ssoCookies.oneSitetokenID === "SLT" + this.hcOneSiteCookie) {
            ssoCookies.oneSitetokenID = this.hcOneSiteCookie;
        }
        if (shouldLoginCookies || userSSoToken || ssoCookies.oneSitetokenID || (ssoCookies.authLogin && ssoCookies.sccCookie)) {
            return ssoCookies;
        }
        return null;
    };
    /**
     * Authenticate user with the following priority
     *
     * If USER_TOKEN is on, use loginCookies
     * If USER_TOKEN is off, try to use authenticateToken
     * if user tokenID is not available, use authenticateCookie
     * with SCC_COOKIE, AUTH_LOGIN
     * Otherwise user is not authenticated
     */
    LoginService.prototype.ssoAuthenticate = function (credentials) {
        var _this = this;
        this.storage.sessionStorage.removeItem('browserSessionId');
        var requestObj = {
            'request': {
                'header': {
                    'apiKey': this.config.get('mdp'),
                    'appName': this.config.getMdpAppName(),
                    'channelName': this.config.get('channelName') || 'WEB',
                    'deviceToken': 'd9708df38d23192e',
                    'deviceType': this.config.getDeviceType(),
                    'lineOfBusiness': 'ICE',
                    'responseFormat': 'JSON',
                    'securityType': 'apiKey',
                    'source': 'MDP_WEB'
                }
            }
        };
        var operationName = '';
        var headers = { ENV: environment.currentEnvStack, operation: '' };
        // Check if loginCookies is enabled
        var userToken = utilityCookie.assertCookieValue(this.config.get('authLoginCookies'), 'ON');
        var userSSoToken = utilityCookie.assertCookieValue(this.config.get('userSSoToken'), 'ON');
        if (userToken || userSSoToken) {
            operationName = 'loginCookies';
        }
        else {
            if (credentials && credentials.oneSitetokenID && credentials.oneSitetokenID !== this.hcOneSiteCookie) {
                requestObj.request.source = 'retail';
                requestObj.request.tokenID = encodeURIComponent(credentials.oneSitetokenID);
                operationName = 'authenticateToken';
            }
            else if (credentials && credentials.sccCookie && credentials.authLogin) {
                requestObj.request.sccCookie = encodeURIComponent(credentials.sccCookie);
                requestObj.request.authLogin = encodeURIComponent(credentials.authLogin);
                requestObj.request.grantType = 'SSOToken';
                requestObj.request.header.securityType = 'tokenId';
                operationName = 'authenticateCookie';
            }
            else {
                return of(false);
            }
        }
        /*
          * Rx Auth POD - RXACCT 185 - 12/10/19
          * for the just Rx-Tied user
          */
        if (this.storage.sessionStorage.getItem('rxm_cache_burst')) {
            headers['X-IceCache'] = 'ignore';
            this.storage.sessionStorage.removeItem('rxm_cache_burst');
        }
        return this.apiService.post(operationName, null, requestObj).pipe(map(function (res) { return _this.authResponse = res; }));
    };
    /**
     * Attempts to authenticate with cookie
     * @Usage: const sub = LoginService.authenticateCookie();
     * if (sub) sub.subscribe( ... )
     * @returns any | boolean or the Api response
     */
    LoginService.prototype.authenticateCookie = function () {
        var _this = this;
        var cookieData = this.getSSOCookieValues();
        if (cookieData) {
            return this.ssoAuthenticate(cookieData).pipe(map(function (response) {
                var resParser = new ResponseValidator(response, true);
                if (resParser.hasHeaders && resParser.statusCode === '0000') {
                    _this.member.details = response.response.detail;
                }
                else {
                    _this.deleteCookies();
                }
                return response;
            }, function (err) {
                console.log('error', err);
                _this.deleteCookies();
                return err;
            }));
        }
        return of(false);
    };
    /**
     * Used to redirect to CSAT if needed
     * param router | angular/router
     */
    LoginService.prototype.requestAuth = function (router, state) {
        var rootUrl = this.config.getHostName();
        var url = (window.location.href).replace(window.location.host, '');
        url = (url).replace(window.location.protocol + '//', '');
        url = url.startsWith('/') ? url : '/' + url;
        /**
         * Native in App redirection
         * will return to same page
         */
        if (!!window.native && typeof window.native.navigateToSignInFromMDP === 'function') {
            return window.native.navigateToSignInFromMDP();
        }
        /**
         * Avoid CSAT beta
         */
        var forceProdAuth = (window.location.host).indexOf('beta') > -1 ? 'https://www.cvs.com' : '';
        /**
         * For local development setup
         * A developer needs to authenticate user
         * in order to display dashboard
         *
         * CSAT: As of 5/20/2019, CSAT or two step login accepts returnUrl as
         * either a queryParameter or a sessionStorage key
         * based on story US467258 -- `/account/login${environment.sit ? '/' : ''} has been updated the url
         * for local use  window.location.href = ((forceProdAuth) + `/account/login/?icid=simpledose-hero-signin`) + this._location.path()
         *                :window.location.href = ((forceProdAuth) + `/account/login/?icid=simpledose-hero-signin`) + this._location.path()
         */
        var rurl = 'https://' + (forceProdAuth || rootUrl) + this.baseHref;
        var rurlWithParams = rurl + window.location.search;
        this.storage.sessionStorage.setItem('returnUrl', isURL(rurlWithParams) ? rurlWithParams : rurl);
        environment.production ?
            window.location.href = ((forceProdAuth) + "/account/login/") + this._location.path()
            : router.navigate(['signin'], { queryParams: state.root.queryParams });
    };
    /**
     * Logout out and clear refreshToken interval
     */
    LoginService.prototype.logout = function () {
        try {
            clearInterval(this.rts);
        }
        catch (e) {
            localConsole.log(e);
        }
        this.deleteCookies();
        this.storage.remove(['token', 'memberDetails', 'activeMemberIndex'], this.storage.sessionStorage);
        this.authState.next({
            authenticated: false
        });
    };
    /**
     * POST logout event to server
     */
    LoginService.prototype.postLogout = function () {
        var headers = this.config.get('isProd') ? {} : {
            env: window.location.host,
            service: 'ProfileService - logoutUser'
        };
        return this.apiService.post('logoutUser', null, {
            'request': {
                'header': {
                    'apiKey': this.config.get('mdp'),
                    'appName': this.config.getMdpAppName(),
                    'channelName': this.config.get('channelName') || 'WEB',
                    'deviceToken': '7777',
                    'deviceType': this.config.getDeviceType(),
                    'responseFormat': 'JSON',
                    'securityType': 'apiKey',
                    'source': 'MDP_WEB',
                    'lineOfBusiness': 'ICE',
                    'type': 'retleg',
                    'tokenID': this.tokenId || this.storage.sessionStorage.getItem('token')
                },
                'hardLogout': 'false'
            }
        }, headers);
    };
    /**
     * Refresh application authentication token
     * remove query params- security debt
     */
    LoginService.prototype.refreshToken = function () {
        var _this = this;
        var ssoDetails = this.getSSOCookieValues();
        var request = {
            request: {
                header: {
                    'apiKey': this.config.get('apiKey'),
                    'appName': this.config.getAppName(),
                    'channelName': this.config.get('channelName'),
                    'deviceToken': 'd9708df38d23192e',
                    'deviceType': this.config.getDeviceType(),
                    'lineOfBusiness': 'ICE',
                    'responseFormat': 'JSON',
                    'securityType': 'tokenId',
                    'source': 'MDP_WEB'
                },
                tokenID: this.tokenId || this.storage.sessionStorage.getItem('token'),
            }
        };
        // No need to pass idType in header
        var s = 'refreshToken';
        this.apiService.post(s, null, request)
            .subscribe(function (success) {
            var resp = success.response;
            if (!resp) {
                return;
            }
            var responseDetail = resp.detail;
            if (resp.header.statusCode === '0000' && responseDetail) {
                var tokenId = responseDetail.ICETokenResponse && responseDetail.ICETokenResponse.tokenId;
                if (tokenId) {
                    _this.saveTokenId(tokenId);
                }
                var onesiteTokenId = responseDetail.OneSitetokenResponse && responseDetail.OneSitetokenResponse.OneSitetokenId;
                if (onesiteTokenId) {
                    _this.createOneSiteCookie(onesiteTokenId);
                }
                else {
                    _this.storage.set('oneSiteRefresh', new Date(), _this.storage.sessionStorage);
                }
            }
            else if (resp.header.statusCode.toString() === '3004') {
            }
        }, function (error) {
            console.log('COOKIE:: Member.service - Failed to refeshToken: ' + error);
            // portalHelper.signalPortal(Constants.COMM_TYPE.DISPLAY_LOADER, false);
            // portalHelper.signalPortal(Constants.COMM_TYPE.PAGE_REDIRECT, 'ICE_FAILURE');
            throw error;
        });
    };
    /**
     * Get active member encMemberId
     */
    LoginService.prototype.getMemberId = function () {
        return this.memberId;
    };
    /**
     * set active member  and update sessionStorage data
     */
    LoginService.prototype.setActiveMember = function (member) {
        var m = this.storage.get('memberDetails', this.storage.sessionStorage);
        this.activeMember = member;
        this.storage.set('activeMemberIndex', this.activeMember.memberIndex, this.storage.sessionStorage);
        m.encMemberId = member.encMemberId;
        // member is always rxTied if caregivee
        m.rxTied = m.rxTied || member.type === 'caregivee';
        this.memberId = member.encMemberId;
        this._setUpAuthSession(m);
    };
    LoginService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LoginService_Factory() { return new LoginService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.MemberService), i0.ɵɵinject(i4.StorageService), i0.ɵɵinject(i5.Location), i0.ɵɵinject(i5.APP_BASE_HREF)); }, token: LoginService, providedIn: "root" });
    return LoginService;
}());
export { LoginService };
